import { render, staticRenderFns } from "./switch-base-plan-dialog.vue?vue&type=template&id=7588f77c&scoped=true"
import script from "./switch-base-plan-dialog.vue?vue&type=script&lang=js"
export * from "./switch-base-plan-dialog.vue?vue&type=script&lang=js"
import style0 from "./switch-base-plan-dialog.vue?vue&type=style&index=0&id=7588f77c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7588f77c",
  null
  
)

export default component.exports